"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadScript = void 0;
var LoadScript = /** @class */ (function () {
    function LoadScript() {
    }
    LoadScript.loadScript = function (src, id) {
        if (document) {
            if (!LoadScript.loading[id]) {
                return new Promise(function (resolve, reject) {
                    var script = document.createElement("script");
                    script.src = src;
                    script.id = id;
                    script.async = true;
                    script.addEventListener("load", function () {
                        resolve();
                    });
                    LoadScript.loading[id] = true;
                    script.addEventListener("error", function (e) {
                        reject(e);
                    });
                    document.body.appendChild(script);
                });
            }
            else {
                return Promise.resolve();
            }
        }
        else {
            return Promise.reject("could not trigger load - document doesn't exist");
        }
    };
    LoadScript.loading = {};
    return LoadScript;
}());
exports.LoadScript = LoadScript;
//# sourceMappingURL=LoadScript.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/services/LoadScript.js
// module id = 1689
// module chunks = 8